module.exports = __webpack_public_path__ + "img/9788980403516.9b94dc7c.jpg";